// extracted by mini-css-extract-plugin
module.exports = {"button":"_b6cc05f"};